import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-social-icons',
  templateUrl: './social-icons.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./social-icons.component.scss']
})
export class SocialIconsComponent implements OnInit {
  readonly iconSize = input<string>('');
  readonly iconColor = input<string>('');
  constructor() { }

  ngOnInit() {
  }

}
